import { render, staticRenderFns } from "./TecalForm.vue?vue&type=template&id=5aa8947e"
import script from "./TecalForm.vue?vue&type=script&lang=js"
export * from "./TecalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports